import { Injectable } from '@angular/core';
import { Network, ConnectionType, ConnectionStatus } from '@capacitor/network';
import { AlertController, ToastController } from '@ionic/angular';
import { Logger } from 'ionic-logging-service';
import { Api } from './api/api';
import { AudioService } from './audio/audio.service';
import { BackgroundMode } from '@anuradev/capacitor-background-mode';
import { SplashScreen } from '@capacitor/splash-screen';

declare let Capacitor: any;
declare let cordova: any;
declare let window: any;
declare let wifiinformation: any;

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  networkType:ConnectionType = 'unknown';
  public signal = '';
  public linkspeed = '';

  private userName = '';
  private alertError:HTMLIonToastElement;
  private interval:any = null;
  private logger: Logger;

  constructor(public api: Api, private alertCtrl: AlertController, private audio:AudioService, private toastCtrl:ToastController) {
    this.audio.preload('plingaudio', 'pling.mp3');
  }

  private getLogger() {
    if(this.logger) {
      return this.logger;
    }

    return this.logger = this.api.getLogger('Hausnotruf.Network');
  }

  private getWifiInfo() {
    // return Promise
    return new Promise<any>((resolve, reject) => {
        // view wifi router info
        wifiinformation.getWifiInfo(
          (data) => {
          // get wifi basic info
            const wifi_info = {
              ssid:
                data.wifi_info.ssid != undefined
                  ? data.wifi_info.ssid.replace(/"/g, "")
                  : "MyHome Wi-Fi",
              bssid: data.wifi_info.bssid,
              frequency: data.wifi_info.frequency,
              channel: data.wifi_info.channel,
              linkspeed: data.wifi_info.link_speed,
              signal: data.wifi_info.signal_strength,
              ip: data.wifi_info.ip,
              mac: data.wifi_info.mac,
            };

            // get wifi DHCP info
            const wifi_dhcp = {
              server: data.wifi_dhcp.dhcp_server,
              ip: data.wifi_dhcp.ip,
              gateway: data.wifi_dhcp.gateway,
              netmask: data.wifi_dhcp.netmask,
              dns1: data.wifi_dhcp.dns1,
              dns2: data.wifi_dhcp.dns2,
              lease: data.wifi_dhcp.lease,
            };
            // return Promise success.
            resolve([wifi_info, wifi_dhcp]);
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  private async showAlert(wlan:number, networkGSM:number) {
    if(!this.alertError && typeof cordova !== 'undefined') {
      this.audio.play('plingaudio');

      const active = await BackgroundMode.isActive();

      if (active.activated) {
        if (this.api.platform.is('android')) {
          await BackgroundMode.wakeUp();
          await BackgroundMode.moveToForeground();
          await BackgroundMode.unlock();
        }
      }

      const msg = (wlan !== null) ? '<br>WLAN Geschwindigkeit: ' + wlan + ' Mbit/s' : '<br>Mobilfunk: ' + networkGSM + ' DB-Level';

      this.alertError = await this.toastCtrl.create({
        message: 'Ihre WLAN/Mobilfunk Verbindung ist zu schlecht.<br>Bitte WLAN/Mobilfunk prüfen.' + msg,
        duration: 5000,
        position: 'top',
        color: 'danger',
        cssClass: 'toast-danger'
      });

      await this.alertError.present();
      await this.alertError.onDidDismiss();
      this.alertError = null;
    }

  }

  addListener() {
    Network.addListener('networkStatusChange', status => {
      if(this.api._user && this.api._user.profile && this.api._user.profile.firstname) {
        this.userName = this.api._user.profile.firstname + ' ' + this.api._user.profile.lastname
      }
      this.getLogger().info('networkStatusChange', {user:this.userName, ...status});
      console.log('Network status changed', status);
    });
  }

  initInterval() {
    if(this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }

    if(Capacitor.platform === "android") {
      this.interval = setInterval(async () => {
        const status:ConnectionStatus = await Network.getStatus();
        this.networkType = status.connectionType;
        if(this.networkType !== 'wifi') {
          window.SignalStrengthDualSim.sim1(
            (dataDbm) => {
              if(parseInt(dataDbm.level) === 0 || (parseInt(dataDbm.level) === 1 && dataDbm.type !== 'lte')) {
                SplashScreen.hide();
                this.showAlert(null, parseInt(dataDbm.level));

                if(this.api._user && this.api._user.profile && this.api._user.profile.firstname) {
                  this.userName = this.api._user.profile.firstname + ' ' + this.api._user.profile.lastname
                }
  
                this.getLogger().info('networkGSM', {user:this.userName, network:dataDbm});
              }
            }
          );
        } else {
          try{
            const wifiData = await this.getWifiInfo();
            this.linkspeed = wifiData[0].linkspeed.replace(/[^0-9]/g,"");
            this.signal = wifiData[0].signal;
            if(parseInt(this.linkspeed) < 10) {

              if(this.api._user && this.api._user.profile && this.api._user.profile.firstname) {
                this.userName = this.api._user.profile.firstname + ' ' + this.api._user.profile.lastname
              }

              this.getLogger().info('networkBadWifi', {user:this.userName, speed:this.linkspeed});
              SplashScreen.hide();
              this.showAlert(parseInt(this.linkspeed), null);

            } else {
              if(this.alertError) {
                await this.alertError.dismiss();
                this.alertError = null;
              }
            }
          } catch(err) {
            console.log(err);
          }
        }
        
      }, 5000);
    }
  }

}
